export enum ScreenFrameType {
  Main = "MAIN_FRAME",
  Custom = "CUSTOM_FRAME"
}
